var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeHeroEllipsGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 493,
    viewBox: "0 0 344 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 240,
    cy: 334,
    r: 238.5,
    transform: "rotate(-180 240 334)",
    stroke: "#FF5349",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 311,
    cy: 190,
    r: 188,
    transform: "rotate(-180 311 190)",
    stroke: "#FF5349",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHeroEllipsGroup);
export default __webpack_public_path__ + "static/media/homeHeroEllipsGroup.3363f219320595ff892482093654e96f.svg";
export { ForwardRef as ReactComponent };